export default function SmoothScroll() {
  // Native scrolling is intentionally used. It is faster and more reliable in
  // mobile in-app browsers than a requestAnimationFrame-driven scroll layer.
  return null;
}
